export default __webpack_public_path__ + "static/media/aboutIcon.7eb532c6.svg";